import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import Icon from '../../components/AppIcon';

const PRIVACY_KEY = 'page_privacy_content';

const PrivacyPage = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [updatedAt, setUpdatedAt] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await supabase
          .from('app_settings')
          .select('value, updated_at')
          .eq('key', PRIVACY_KEY)
          .single();
        if (data) {
          setContent(data.value || '');
          setUpdatedAt(data.updated_at);
        }
      } catch {
        // silently fall through; empty content shows fallback
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className="min-h-screen bg-slate-50" dir="rtl">
      {/* Hero Header */}
      <div className="bg-white border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-sm text-slate-500 hover:text-slate-800 transition-colors mb-6"
          >
            <Icon name="ArrowRight" size={16} />
            رجوع
          </button>
          <div className="flex items-center gap-4 mb-4">
            <div className="w-12 h-12 rounded-2xl bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="Shield" size={24} className="text-primary" />
            </div>
            <div>
              <h1
                className="text-2xl sm:text-3xl font-bold text-slate-900"
                style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}
              >
                سياسة الخصوصية
              </h1>
              {updatedAt && (
                <p className="text-sm text-slate-400 mt-0.5">
                  آخر تحديث:{' '}
                  {new Date(updatedAt).toLocaleDateString('ar-SA-u-ca-gregory-nu-latn', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        {loading ? (
          <div className="flex items-center justify-center py-20">
            <div className="text-center">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary mx-auto mb-3" />
              <p className="text-sm text-slate-500">جاري التحميل...</p>
            </div>
          </div>
        ) : content ? (
          <div
            className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 sm:p-8 page-content"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        ) : (
          <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-12 text-center">
            <Icon name="Shield" size={40} className="text-slate-300 mx-auto mb-3" />
            <p className="text-slate-500" style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}>
              لم يتم إضافة محتوى لهذه الصفحة بعد
            </p>
          </div>
        )}
      </div>

      <style>{`
        .page-content h2 {
          font-size: 1.4rem;
          font-weight: 700;
          color: #0f172a;
          margin-top: 2rem;
          margin-bottom: 0.75rem;
          padding-bottom: 0.5rem;
          border-bottom: 2px solid #e2e8f0;
          font-family: 'IBM Plex Sans Arabic', sans-serif;
        }
        .page-content h2:first-child { margin-top: 0; }
        .page-content h3 {
          font-size: 1.1rem;
          font-weight: 700;
          color: #1e293b;
          margin-top: 1.5rem;
          margin-bottom: 0.5rem;
          font-family: 'IBM Plex Sans Arabic', sans-serif;
        }
        .page-content p {
          color: #475569;
          line-height: 1.9;
          margin-bottom: 1rem;
          font-size: 0.95rem;
          font-family: 'IBM Plex Sans Arabic', sans-serif;
        }
        .page-content ul, .page-content ol {
          padding-right: 1.5rem;
          margin-bottom: 1rem;
        }
        .page-content li {
          color: #475569;
          line-height: 1.9;
          margin-bottom: 0.35rem;
          font-size: 0.95rem;
          font-family: 'IBM Plex Sans Arabic', sans-serif;
        }
        .page-content strong {
          color: #1e293b;
          font-weight: 700;
        }
        .page-content .updated-at {
          font-size: 0.8rem;
          color: #94a3b8;
          margin-top: 2rem;
          padding-top: 1rem;
          border-top: 1px solid #e2e8f0;
        }
      `}</style>
    </div>
  );
};

export default PrivacyPage;
